import React, { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { initMetaPixel } from "./utils/metaPixel";
import { StatusStrip } from "./components/layout/StatusStrip";
import { SiteHeader } from "./components/layout/SiteHeader";
import { SiteFooter } from "./components/layout/SiteFooter";
import { MobileOfferBar } from "./components/layout/MobileOfferBar";
import { Hero } from "./components/sections/Hero";
import { StatStrip } from "./components/sections/StatStrip";
import { OpenLookTeach } from "./components/sections/OpenLookTeach";
import { UnitSection } from "./components/sections/UnitSection";
import { RouteSection } from "./components/sections/RouteSection";
import { SessionSection } from "./components/sections/SessionSection";
import { InsidePreviewSection } from "./components/sections/InsidePreviewSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { FaqSection } from "./components/sections/FaqSection";
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk868ye44bdj">
      <div className="min-h-screen w-full bg-ice font-body text-body" data-id="element-1" data-mp="3mj6k9yvk64h1">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-[8px] focus:bg-orange focus:px-5 focus:py-3 focus:text-navy" data-id="element-2" data-mp="3rcsulke91w9o">
          Skip to content
        </a>
        <StatusStrip data-id="element-3" data-mp="33m5b01uz1i7a" />
        <SiteHeader data-id="element-4" data-mp="33nq4do5juv3k" />
        <main id="main" tabIndex={-1} className="outline-none" data-id="element-5" data-mp="33n6wl09m5n39">
          <Hero data-id="element-6" data-mp="38li7zffk45nl" />
          <StatStrip data-id="element-7" data-mp="38l04pyuh8r66" />
          <OpenLookTeach data-id="element-8" data-mp="38kglmet3bwqk" />
          <UnitSection data-id="element-9" data-mp="3dkuwe4m2tksa" />
          <RouteSection data-id="element-10" data-mp="3dl4n5uey3vz1" />
          <SessionSection data-id="element-11" data-mp="3dlnwimqj5c1g" />
          <InsidePreviewSection data-id="element-12" data-mp="3dirvgpjdy78s" />
          <BonusesSection data-id="element-13" data-mp="nw2a60hx7gog" />
          <OfferSection data-id="element-14" data-mp="nur762waucye" />
          <FaqSection data-id="element-15" data-mp="nvanjf6awtab" />
        </main>
        <SiteFooter data-id="element-16" data-mp="sudlygrs019b" />
        <MobileOfferBar data-id="element-17" data-mp="stkmm0v5ce17" />
      </div>
    </MotionConfig>;
}